import { useLazyQuery } from "@apollo/client";
import { Pagination, Row, Spin } from "antd";
import { motion } from "framer-motion";
import React from "react";
import { FaSearch } from "react-icons/fa";
import { IoLocation, IoMegaphone } from "react-icons/io5";
import { useHistory } from "react-router-dom";
import countryList from "react-select-country-list";
import {
  componentTransition,
  componentTransitionProp,
} from "../../animation/index";
import { SCHOOL_SEARCH } from "../../app/apollo/index";
import { useAppSelector } from "../../app/hooks";
import { DropDown } from "../../globalComponents/DropDown";
import {
  BigContentContainer,
  FilterButton,
  Label,
} from "../../globalComponents/globalStyle";
import { userInfo } from "../../globalComponents/slice/userDataSlice";
import { TextInput } from "../../globalComponents/TextInput";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { Text, UniAvatar, UniCard } from "./style";

const Education = () => {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const userDetails = useAppSelector(userInfo);
  const [defaultCountry, setDefaultCountry] = React.useState();
  const [country, setCountry] = React.useState();
  const [schoolName, setSchoolName] = React.useState("");
  const [schoolList, setSchoolList] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<any>(1);
  const [allPages, setAllPages] = React.useState<any>();
  console.log("school name", schoolName);
  console.log("country", country);
  const options = React.useMemo(() => countryList().getData(), []);
  const [schoolSearch, searchSchoolData] = useLazyQuery(SCHOOL_SEARCH, {
    fetchPolicy: "cache-and-network",
  });
  interface SearchInterface {
    country?: string;
    schoolName?: string;
  }
  React.useEffect(() => {
    handleSchoolSearch(defaultCountry, "", currentPage);
  }, [defaultCountry]);

  React.useEffect(() => {
    setDefaultCountry(userDetails?.defaultDestination);
  }, [userDetails]);

  const handleSchoolSearch = async (
    countryLocation?: any,
    school?: any,
    current?: number
  ) => {
    setSchoolList([]);
    try {
      schoolSearch({
        variables: {
          byCountry: countryLocation,
          byName: school,
          requestedPage: current,
        },
      });
    } catch (e) {
      NotificationAlert("error", "Error occured", "Try Again");
      console.log(e);
      setLoading(false);
    }
  };
  console.log(searchSchoolData);
  console.log(schoolList);
  React.useEffect(() => {
    if (searchSchoolData?.error) {
      setLoading(false);

      NotificationAlert("error", "Error occured", "Try Again");
    } else if (searchSchoolData?.data?.schoolSearch) {
      setLoading(false);
      setAllPages(searchSchoolData?.data?.schoolSearch?.last_page);
      console.log(
        "my last page is",
        searchSchoolData?.data?.schoolSearch?.last_page
      );
      setSchoolList(searchSchoolData?.data?.schoolSearch?.School);
    } else if (searchSchoolData?.loading === true) {
      setLoading(true);
    }
  }, [searchSchoolData]);
  console.log("sample school data", searchSchoolData);
  const list = schoolList?.map((school: any, id: any) => (
    <UniCard
      onClick={() =>
        history.push({ pathname: `/home/education/details`, state: { school } })
      }
      key={id}
    >
      <Row style={{ alignItems: "center" }}>
        <UniAvatar>{school?.name?.charAt(0) || ""}</UniAvatar>
        <div style={{ flex: 1 }} className="title-medium">
          {school?.name}
        </div>
      </Row>
      <Row style={{ alignItems: "center", margin: "7px 0" }}>
        <IoLocation style={{ margin: "0 5px" }} />
        <div style={{}} className="title-medium">
          {school?.country}
        </div>
      </Row>
    </UniCard>
  ));
  const changeHandler = (value: any) => {
    setCountry(value);
    console.log("value from dropdown", value);
  };
  //   console.log(countryy);
  console.log("the user details", userDetails);
  const handleBackChange = () => {
    if (currentPage > 1) {
      handleSchoolSearch(country, schoolName, currentPage - 1);
      setCurrentPage(currentPage - 1);
    }
  };
  const handleForwardChange = () => {
    if (currentPage < allPages) {
      handleSchoolSearch(country, schoolName, currentPage + 1);
      setCurrentPage(currentPage + 1);
    }
  };
  function itemRender(current?: any, type?: any, originalElement?: any) {
    if (type === "prev") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleBackChange}>
          Previous
        </h5>
      );
    }
    if (type === "next") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleForwardChange}>
          Next
        </h5>
      );
    }
    return originalElement;
  }
  return (
    <motion.div
      variants={componentTransition}
      initial="initial"
      animate="in"
      exit="out"
      transition={componentTransitionProp}
    >
      <BigContentContainer>
        <h1 className="title-bold" style={{ margin: 0 }}>
          Schools
        </h1>
        <div className="title-regular">
          List of schools in your selected location
        </div>
        <div>
          <Row
            style={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <h3 className="title-medium">
              {schoolList?.length > 0
                ? `${allPages}
               list found`
                : "0 list found "}
            </h3>
            <Row>
              <div style={{ width: "300px", marginRight: "15px" }}>
                <Label style={{ marginLeft: "-10px" }}>
                  <h3 className="title-regular"> School Name</h3>
                </Label>
                <TextInput
                  placeholder="Type school name here..."
                  onChange={(e: any) => setSchoolName(e.target.value)}
                />
              </div>

              <div style={{ width: "300px", marginRight: "15px" }}>
                <Label style={{ marginLeft: "-10px" }}>
                  <h3 className="title-regular"> Country</h3>
                </Label>
                <DropDown
                  values={options}
                  onChange={(e) => changeHandler(e.target.value)}
                />
              </div>
              <div style={{ margin: "auto", cursor: "pointer" }}>
                <FilterButton>
                  <div>
                    <FaSearch
                      size={27}
                      color="#3b72bb"
                      style={{ marginTop: "25px" }}
                      onClick={() =>
                        handleSchoolSearch(country, schoolName, currentPage)
                      }
                    />
                  </div>
                  <button
                    onClick={() =>
                      handleSchoolSearch(country, schoolName, currentPage)
                    }
                  >
                    Filter
                  </button>
                </FilterButton>
                {/* <LoggerButton
                loading={loading}
                onClick={() => handleSchoolSearch(country, schoolName)}
                text="Filter"
              /> */}
              </div>
            </Row>
          </Row>
          {loading && (
            <Row>
              <Text>loading... please wait</Text> <Spin />
            </Row>
          )}{" "}
          {schoolList?.length === 0 && !loading && (
            <div
              style={{ width: "100%", display: "grid", placeItems: "center" }}
            >
              <IoMegaphone size={70} />
              <Text>Sorry, no match found</Text>
            </div>
          )}
          <br />
        </div>
        <Row style={{ height: "100%" }} justify="space-between">
          {schoolList && list}

          {/* <Col md={{ span: 0 }}>
            <FilterContainer>
              <h3>Filter schools by:</h3>
              <div>
                <Label>
                  <h3> School Name</h3>
                </Label>
                <TextInput
                  placeholder="Type school name here..."
                  onChange={(e: any) => setSchoolName(e.target.value)}
                />
                <br />
                <Label>
                  <h3> Country</h3>
                </Label>
                <DropDown
                  values={options}
                  onChange={(e) => changeHandler(e.target.value)}
                />
              </div>
              <LoggerButton
                loading={loading}
                onClick={() => handleSchoolSearch(country, schoolName)}
                text="Filter"
              />
            </FilterContainer>
          </Col>
         */}
        </Row>
        {schoolList?.length > 0 && (
          <Pagination
            style={{ marginBottom: "10vh" }}
            current={currentPage}
            total={allPages}
            pageSize={1}
            defaultPageSize={allPages}
            showSizeChanger={false}
            itemRender={itemRender}
            showTotal={(total) => `Total: ${total} list`}
          />
        )}
      </BigContentContainer>
    </motion.div>
  );
};

export default Education;
